// extracted by mini-css-extract-plugin
export default {"backdrop":"BNJbua2BdGTknpp","fullscreen":"F1ZyAX_jLnOEELU","entering":"O4iJcEwHlOkaUaS","slide-top":"hS9gksL3gWoTF3y","exiting":"CKpXLAzrpzvt4Hl","slide-bottom":"IL5KpJW3cvu3Yaa"};